import { AutogenModelOrderStops, AutogenRowOrderStops } from "./autogen/AutogenModelOrderStops";

export class ModelOrderStops extends AutogenModelOrderStops<RowOrderStops> {
    constructor() {
        super(RowOrderStops);
    }
}

export class RowOrderStops extends AutogenRowOrderStops {
}